import { getFirstPermittedAdminPath } from "../../../Util/adminPermissions";
import { RootState } from "../../../Redux/store";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import React from "react";

interface PublicRouteProps {
  children: React.ReactNode;
  isAuthPage?: boolean;
  isAdmin?: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  isAuthPage = false,
  isAdmin = false,
}) => {
  const { token, user, admin, adminToken, adminPermissions } = useSelector(
    (state: RootState) => state.auth,
  );
  const isAuthenticated = token && user;
  const isAdminAuthenticated = admin && adminToken;

  if (isAdmin && isAdminAuthenticated && isAuthPage) {
    return (
      <Navigate to={getFirstPermittedAdminPath(adminPermissions)} replace />
    );
  }

  if (isAuthenticated && isAuthPage && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
